import React, { useState } from "react";
import { Link } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { PlusIcon } from "lucide-react";
import { faqGroups } from "../../data/faqs";
import { spring } from "../../utils/motion";
export function Faq() {
  const [open, setOpen] = useState<string | null>(faqGroups[0].items[0].q);
  return <div className="mx-auto max-w-4xl px-5 py-16 md:px-8 md:py-24" data-id="element-1780" data-mp="1m3tx0fmfykb1">
      <h1 className="text-[clamp(38px,6vw,64px)] font-bold leading-[1.05] tracking-[-0.02em]" data-id="element-1781" data-mp="2jo6ec4k048g5">Questions, answered.</h1>
      <p className="mt-4 max-w-[52ch] text-[17px] text-ink-2" data-id="element-1782" data-mp="2er6ewchnq3y0">
        Can't find it here? <Link to="/contact" className="font-semibold text-ink underline underline-offset-4" data-id="element-1783" data-mp="29y3kk2522qgr">Ask us directly</Link>.
      </p>

      <div className="mt-12 space-y-12" data-id="element-1784" data-mp="24yh4zm1r8y4s">
        {faqGroups.map(g => <section key={g.title} aria-labelledby={`faq-${g.title}`} data-id="element-1785" data-mp="32hjxzdi9ksgg">
            <h2 id={`faq-${g.title}`} className="text-sm font-bold text-brand" data-id="element-1786" data-mp="2xoz6iimtyrg3">
              {g.title}
            </h2>
            <ul className="mt-3 space-y-3" data-id="element-1787" data-mp="2te6bf1c0f313">
              {g.items.map(item => {
            const isOpen = open === item.q;
            const id = `faq-${item.q.slice(0, 12).replace(/\W/g, "")}`;
            return <li key={item.q} className={`rounded-card border-3 border-line bg-surface ${isOpen ? "shadow-brutal" : ""}`} data-id="element-1788" data-mp="2jl8v91uhpq5n">
                    <h3 data-id="element-1789" data-mp="29odzgqplq3v2">
                      <button type="button" onClick={() => setOpen(isOpen ? null : item.q)} aria-expanded={isOpen} aria-controls={id} className="focus-ring flex w-full items-center justify-between gap-4 rounded-card px-5 py-4 text-left text-[17px] font-bold text-ink" data-id="element-1790" data-mp="29o49320n9uou">
                        {item.q}
                        <motion.span animate={{
                    rotate: isOpen ? 45 : 0
                  }} transition={spring.snappy} className="shrink-0" data-id="element-1791" data-mp="3vxhfmwz0e1h">
                          <PlusIcon className="h-5 w-5" strokeWidth={2.75} data-id="element-1792" data-mp="1hsd3oaxu21x" />
                        </motion.span>
                      </button>
                    </h3>
                    <AnimatePresence initial={false} data-id="element-1793" data-mp="3tnfo4ozdc6qw">
                      {isOpen && <motion.div id={id} initial={{
                  opacity: 0,
                  y: -4
                }} animate={{
                  opacity: 1,
                  y: 0
                }} exit={{
                  opacity: 0,
                  transition: {
                    duration: 0.1
                  }
                }} transition={spring.stable} data-id="element-1794" data-mp="3oo2v1mhwm3fv">
                          <p className="px-5 pb-5 text-[16px] leading-relaxed text-ink-2" data-id="element-1795" data-mp="beon5yghiw8l">{item.a}</p>
                        </motion.div>}
                    </AnimatePresence>
                  </li>;
          })}
            </ul>
          </section>)}
      </div>
    </div>;
}